import { Component } from '@theme/component';

const STEP_MS = 450;
const DELTA_MIN = 4;

class SodGalleryEnhance extends Component {
  #rail = null;
  #slideshow = null;
  #last = 0;

  connectedCallback() {
    super.connectedCallback();

    const section =
      document.getElementById(`shopify-section-${this.dataset.sectionId}`) ?? this.closest('.shopify-section');
    const gallery = section?.querySelector('media-gallery');
    if (!gallery) return;

    const badge = this.dataset.badge?.trim();
    if (badge && !gallery.querySelector('.sod-pdp-badge')) {
      const pill = document.createElement('span');
      pill.className = 'sod-pdp-badge';
      pill.textContent = badge;

      (gallery.querySelector('slideshow-component') ?? gallery).append(pill);
    }

    this.#slideshow = gallery.querySelector('slideshow-component');
    this.#rail = gallery.querySelector('slideshow-controls[thumbnails]');
    this.#rail?.addEventListener('wheel', this.#onWheel, { passive: false });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#rail?.removeEventListener('wheel', this.#onWheel);
  }

  #onWheel = (event) => {
    const slideshow = this.#slideshow;
    if (!slideshow || typeof slideshow.next !== 'function') return;
    if (window.matchMedia('(max-width: 749px), (prefers-reduced-motion: reduce)').matches) return;

    const delta = event.deltaY;
    if (Math.abs(delta) < DELTA_MIN) return;

    const slides = slideshow.slides ?? slideshow.querySelectorAll('slideshow-slide');
    const index =
      typeof slideshow.current === 'number'
        ? slideshow.current
        : [...slides].findIndex((slide) => slide.getAttribute('aria-hidden') === 'false');
    const forward = delta > 0;

    if (index >= 0 && (forward ? index === slides.length - 1 : index === 0)) return;

    event.preventDefault();

    const now = performance.now();
    if (now - this.#last < STEP_MS) return;
    this.#last = now;

    forward ? slideshow.next() : slideshow.previous();
  };
}

if (!customElements.get('sod-gallery-enhance')) customElements.define('sod-gallery-enhance', SodGalleryEnhance);
